export enum DocumentationType {
    FULL = 'FULL',
    STREAMLINE = 'STREAMLINE'
}

export const documentationTypeDisplay = {
    [DocumentationType.FULL]: 'Full',
    [DocumentationType.STREAMLINE]: 'Streamline'
};
